module.exports = __webpack_public_path__ + "img/logo.1214c036.svg";